export default __webpack_public_path__ + "static/media/image.1a8f082e.svg";